/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewStoredAddressRequest } from '../../models/new-stored-address-request';
import { StoredAddress } from '../../models/stored-address';

export interface CreateAddress$Params {
      body: NewStoredAddressRequest
}

export function createAddress(http: HttpClient, rootUrl: string, params: CreateAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<StoredAddress>> {
  const rb = new RequestBuilder(rootUrl, createAddress.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoredAddress>;
    })
  );
}

createAddress.PATH = '/api/v1/addresses';
